import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-c',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-c.component.html',
  styleUrl: './section-c.component.css'
})
export class SectionCComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionCForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'school_attacks',
      questionText: 'School attacks or attackers?',
      formControlName: 'school_attacks',
      infoFormControlName: 'school_attacks_explanation',
      label: 'Please explain: *'
    },
    {
      id: 'weapons',
      questionText: 'Weapons or dangerous materials? *',
      formControlName: 'weapons',
      infoFormControlName: 'weapons_explanation',
      label: 'Please explain: *'
    },
    {
      id: 'mass_violence',
      questionText: 'Incidents of mass violence (terrorism, workplace violence, mass murderers)? *',
      formControlName: 'mass_violence',
      infoFormControlName: 'mass_violence_explanation',
      label: 'Please explain: *'
    },
    {
      id: 'death_preoccupation',
      questionText: 'Preoccupation with death, violent themes or school attacks? *',
      formControlName: 'death_preoccupation',
      infoFormControlName: 'death_preoccupation_explanation',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['c_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.c_additional_info) || this.yesNo.No, Validators.required);

    this.sectionCForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionCForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionCForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionC(): void {
    if (this.sectionCForm.valid) {
      this.onSaveSection5.emit(this.sectionCForm.value);
    }
  }

}
